export enum ActivityStatus {
  IN_PROGRESS = 'InProgress',
  IN_REVIEW = 'InReview',
  COMPLETED = 'Completed',
  REMOVED = 'Removed',
}
